export default __webpack_public_path__ + "static/media/5.de85fa01.jpg";